import { useBrandingContext } from "@/contexts/BrandingContext";
import { DashboardInfoContext } from "@/store/DashboardProvider";
import React from "react";
import { CallIcon } from "../atoms";
import { EmailOutlined, WhatsApp, CallOutlined } from "@mui/icons-material";

export const IntroductoryText = () => {
  const { email, tel, whatsApp } = useBrandingContext();
  const {
    state: { isExpressConvertedToNEForm },
  } = React.useContext(DashboardInfoContext);
  return (
    <div>
      <p>
        <b style={{ textDecoration: "underline" }}>Useful tips:</b>
      </p>
      <ol>
        <li>
          To add extra accounts, press{" "}
          <b>{isExpressConvertedToNEForm ? "+ Add more accounts" : "+ Add account"}</b>.
        </li>
        <li>
          For each company, the <b>Account updates</b> section holds important documents and
          information. Use the messaging box there, to ask us questions or send information.
        </li>
        <li>
          Keep an eye on the <b>Requires your attention</b> section, as we may need something extra
          from you to complete the account request.
        </li>
        <li>
          If you need any <b>other services</b> from our Partners, please select them below.
        </li>
        <li>
          To speak to one of our team send us Email at{" "}
          <EmailOutlined fontSize="small" sx={{ verticalAlign: "middle" }} /> <b>{email}</b>,
          WhatsApp us at{" "}
          <WhatsApp fontSize="small" color="success" sx={{ verticalAlign: "middle" }} />{" "}
          <b>{whatsApp}</b> or Call us at{" "}
          <CallOutlined fontSize="small" sx={{ verticalAlign: "middle" }} /> <b>{tel}</b> (9am to
          5pm, Monday to Friday).
        </li>
      </ol>
    </div>
  );
};
